import Menu from '../BGH-RD3';

// import MobileMenu from './mobileMenu';
// import DesktopMenu from './desktopMenu';
// import {Main} from 'components/Shared/Layout';

// interface OwnProps {
//   className?: string
// }

// export default ({
//   className
// }: OwnProps) => (
//   <Main appearance="secondary" className={className}>
//     <DesktopMenu key="menuDesktop" />
//     <MobileMenu key="menuMobile" />
//   </Main>
// );

export default Menu;
